/**
 * Some self-hosted / migrated tables have created_at NOT NULL without DEFAULT now().
 * Always stamp inserts so we never rely on DB defaults.
 */
export function stampCreatedAt(row) {
  if (row == null) return row;
  if (Array.isArray(row)) return row.map((item) => stampCreatedAt(item));
  if (typeof row !== 'object') return row;
  const existing = row.created_at;
  if (existing != null && String(existing).trim() !== '') return row;
  return { ...row, created_at: new Date().toISOString() };
}

/** created_at + updated_at — for tables that require both WITHOUT DB defaults. */
export function stampTimestamps(row) {
  if (row == null) return row;
  if (Array.isArray(row)) return row.map((item) => stampTimestamps(item));
  if (typeof row !== 'object') return row;
  const now = new Date().toISOString();
  const next = { ...row };
  if (next.created_at == null || String(next.created_at).trim() === '') {
    next.created_at = now;
  }
  if (next.updated_at == null || String(next.updated_at).trim() === '') {
    next.updated_at = now;
  }
  return next;
}
